
module.exports = {
	context: {
		container: {
			title: 'container'
		},
		component: {
			cardTeaserHeader : 'Välkommen till Försvarets materielverk',
			cardTeaser: [
				{title:'Jobb & Karriär', header: 'Hitta ditt drömjobb', content:'Vi uppskattar avancerade helikoptrar, ubåtar och flygplan. Och vi tar vårt uppdrag att leverera materiel och tjänster till Sveriges försvar på största allvar. Men vi är mycket mer än så. Vi är ett av Sveriges bästa karriärföretag.', bgColor:'green', ratio:'1x1', bgImage:'/images/demo-soldat-1.jpg'},
				{title:'Vår verksamhet', header: 'Våra experter', content:'Vi ser till att det svenska försvaret har den utrustning och de kringtjänster de behöver för att utföra sitt uppdrag.', bgColor:'egg-shell', ratio:'1x1'},
				{title:'Om FMV', header: 'Hur vi hjälper till att försvara Sverige', content: 'I 50 år har vi levererat varor och tjänster till det svenska försvaret. Idag handlar det inte bara om att anskaffa materiel. Vi underhåller också materielen under hela dess livstid.', bgColor:'green', ratio:'1x1'},
				{title:'Våra projekt', header: 'Delta i upphandling', content:'Varje år driver vi 200 projekt från soldatkängor till ubåtsutveckling. Vi gör det tillsammans med kunder och leverantörer i integrerade projektteam.', bgColor:'greyish-brown', ratio:'1x1', bgImage:'/images/demo-soldat-2.jpg'}
			],
		}
	}
};
